import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getEHRCallback } from '../../SuperAdmin/store/actions/ehrcredentials.action';

export const EHRCallback = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const { ehrCallbackSuccess } = useSelector(
    (state) => state?.ehrCredentialsState
  );
  const { currentPractitioner } = useSelector(
    (state) => state?.practitionerState
  );

  useEffect(() => {
    // Get code from URL query parameters
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get('code');

    if (code && currentPractitioner?.org_uuid) {
      dispatch(getEHRCallback(code, 'drchrono', currentPractitioner.org_uuid));
    }
  }, [currentPractitioner, dispatch, location.search]);

  useEffect(() => {
    if (ehrCallbackSuccess) {
      window.location.href =
        import.meta.env.VITE_AMBIENT_UI_BASE_URL + '/settings';
    }
  }, [ehrCallbackSuccess]);

  return (
    <div className="flex items-center justify-center h-screen">
      <div>Processing authorization...</div>
    </div>
  );
};

export default EHRCallback;
